import { Navbar } from "react-bootstrap";

export const MenuArea = (props : { children : any, bg?: string }) => {
  return (
    <Navbar bg={props.bg} variant={props.bg} expand={false}>
       {props.children}
    </Navbar>

  );
};
